.pill {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 5px 11px 5px 9px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 999px;
}

.dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
}

/* На тёмной плашке заливка из светлой палитры не читается, поэтому
   там используется полупрозрачный белый, а цвет несёт только точка. */
.onHero {
  color: var(--hero-fg);
  background: rgb(255 255 255 / 12%);
}

.onHero .dot {
  background: var(--tone);
}

.positive {
  color: var(--ok);
  background: var(--ok-wash);
}

.warning {
  color: var(--warn);
  background: var(--warn-wash);
}

.critical {
  color: var(--danger);
  background: var(--danger-wash);
}

.neutral {
  color: var(--muted);
  background: var(--surface-sunken);
}
